var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-avatar-base",style:(_vm.styles)},[_c('img',{attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }